export type StageControl = 'exit' | 'prev' | 'next' | 'mark' | 'hide'

export type StageMarkupOptions = {
  controls?: readonly StageControl[]
}

const DEFAULT_CONTROLS: readonly StageControl[] = ['exit', 'prev', 'next', 'mark', 'hide']

export function stageMarkup(options: StageMarkupOptions = {}): string {
  const controls = new Set(options.controls ?? DEFAULT_CONTROLS)
  const control = (name: StageControl, markup: string) => (controls.has(name) ? markup : '')

  return `
<div class="stage-root" data-stage-root hidden>
  <div class="stage-canvas" data-stage-canvas></div>
  <div class="stage-hud glass-hud" data-stage-hud>
    <div class="glass-hud__inner">
      ${control('exit', '<button type="button" class="glass-btn" data-stage="exit" data-i18n="exit">Exit</button>')}
      ${control('prev', '<button type="button" class="glass-btn" data-stage="prev" data-i18n="prev">Prev</button>')}
      ${control('next', '<button type="button" class="glass-btn" data-stage="next" data-i18n="next">Next</button>')}
      ${control('mark', '<button type="button" class="glass-btn" data-stage="mark" data-i18n="mark">Mark</button>')}
      ${control('hide', '<button type="button" class="glass-btn glass-btn--ghost" data-stage="hide" data-i18n="hide_hud">Hide</button>')}
      <span class="mono" data-stage-label></span>
    </div>
  </div>
  <button type="button" class="stage-fullscreen-cta glass-btn glass-btn--prominent" data-stage="fullscreen" data-i18n="fullscreen" hidden>Enter fullscreen</button>
  <div class="stage-hint" data-stage-hint hidden>
    <span data-i18n="hidden_hint_exit">Press Esc to exit fullscreen</span>
    <span data-stage-hint-next data-i18n="hidden_hint_next"> · Click the screen for the next step</span>
    <span data-stage-hint-fullscreen data-i18n="hidden_hint_fullscreen" hidden> · Click the screen to enter fullscreen</span>
  </div>
</div>`
}
